import React, { useContext, useEffect } from "react";
import { Input, Space, Form, Checkbox } from "antd";
import { Link, useLocation, useHistory } from 'react-router-dom';
import { Context } from '../../contexts/Account';
import { GoogleLogin } from 'react-google-login';

function Register() {
    const location = useLocation();
    const { onRegister, loginAccount } = useContext(Context);
    const history = useHistory();
    const onFinish = (values) => {
        onRegister(values);
        
        
    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const responseGoogle = (response) => {
        // console.log(response);
    }
    useEffect(() => {
        if (loginAccount) {
            history.push('/profile')
        }
    }, [loginAccount])
    return (
        <div class="register" style={{
            backgroundImage: `url("/images/bg_res.png")`,
        }}>
            <div className="container">
                <div className="logo_Register">
                    <Link to="/"><img className="img-fluid" src="/images/logo_res.png" alt="" /></Link>
                </div>
                <div className="registerContent">
                    <div className="smartHotelWidget">
                        <div className="itemBox"
                            style={{
                                backgroundImage: `url("/images/ic_bg_slider.png")`,
                            }}>
                            <div className="contentBox">
                                <img src="/images/ic_pig_res.png" alt="" />
                                <div className="content">
                                    <p>Đặt phòng trực tiếp</p>
                                    <h5>Giá tốt nhất</h5>
                                </div>
                            </div>
                        </div>
                        <div className="itemBox"
                            style={{
                                backgroundImage: `url("/images/ic_bg_slider.png")`,
                            }}>
                            <div className="contentBox">
                                <img src="/images/ic_check_in_res.png" alt="" />
                                <div className="content">
                                    <p>Nhận phòng</p>
                                    <h5>Không đặt cọc</h5>
                                </div>
                            </div>

                        </div>
                        <div className="itemBox"
                            style={{
                                backgroundImage: `url("/images/ic_bg_slider.png")`,
                            }}>
                            <div className="contentBox">
                                <img src="/images/ic_money_time_res.png" alt="" />
                                <div className="content">
                                    <p>
                                        Đặt phòng</p>
                                    <h5>
                                        Nhận phòng

                                    </h5>
                                </div>
                            </div>

                        </div>
                        <div className="itemBox"
                            style={{
                                backgroundImage: `url("/images/ic_bg_slider.png")`,
                            }}>
                            <div className='contentBox'>
                                <img src="/images/ic_tablet_res.png" alt="" />
                                <div className="content">
                                    <p>Điều khiển phòng</p>
                                    <h5>Bằng Tablet</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="smartHotelregister ">
                        <div className="row">
                            <div className="col-lg-5 col-12 col-md-5 smartHotelregisterLeft">
                                <div className="imageWellCome">
                                    <img className="img-fluid" src="/images/wellcome.png" alt="" />
                                </div>
                                <h5>ĐĂNG NHẬP BẰNG TÀI KHOẢN</h5>
                                <div className="loginWithFbGoogle">
                                    <div className="LoginWithFb">
                                        <button className="BtnLoginWith btnLoginWithFb">
                                            <img className="img-fluid" src="/images/ic_facebook.png" alt="" /> FaceBook
                                        </button>
                                    </div>
                                    <div className="LoginWithGoogle">
                                        <GoogleLogin
                                            clientId="658977310896-knrl3gka66fldh83dao2rhgbblmd4un9.apps.googleusercontent.com"
                                            render={renderProps => (
                                                <button className="BtnLoginWith btnLoginWithGoogle" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                                                    <img className="img-fluid" src="/images/ic_google.png" alt="" /> Google
                                                </button>
                                            )}
                                            buttonText="Login"
                                            onSuccess={responseGoogle}
                                            onFailure={responseGoogle}
                                            cookiePolicy={'single_host_origin'}
                                            isSignedIn={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7 col-12 col-md-7 smartHotelregisterRight">
                                <Form
                                    destroyOnClose={true}
                                    onFinish={onFinish}
                                    onFinishFailed={onFinishFailed}>
                                    <h5>Đăng ký mới</h5>
                                    <Form.Item className="formInput"
                                        label="Họ và tên"
                                        name="fullname"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Trường này không được bỏ trống',
                                            }
                                        ]}
                                    >
                                        <Input
                                            type="text"
                                            placeholder="Nhập họ và tên của bạn"
                                        />
                                    </Form.Item>
                                    <Form.Item className="formInput"
                                        label="EMAIL HOẶC SỐ ĐIỆN THOẠI"
                                        name="email"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Trường này không được bỏ trống',
                                            },
                                            {
                                                pattern: /^[a-zA-Z0-9_\.%\+\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,}$/,
                                                message: 'Email không đúng định dạng',
                                            }
                                        ]}
                                    >
                                        <Input
                                            type="text"
                                            placeholder="Nhập email hoặc số điện thoại"
                                        />
                                    </Form.Item>
                                    <Form.Item className="formInput password"
                                        label="MẬT KHẨU"
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Trường này không được bỏ trống',
                                            }
                                        ]}
                                    >
                                        <Space direction="vertical">
                                            <Input.Password placeholder="input password" />
                                        </Space>
                                    </Form.Item>
                                    <Form.Item className="formInput check"
                                        name="check"
                                        valuePropName="checked"
                                    >
                                        <Checkbox>Nhận thông báo để không bỏ lỡ ưu đãi từ Mandala</Checkbox>
                                    </Form.Item>
                                    <p>Bấm vào việc đăng kí, JO đồng ý chính sách Mandala.</p>
                                    <Form.Item className="btnModal">
                                        <button className="btnStyle" >
                                            Đăng ký
                                        </button>
                                    </Form.Item>
                                    <div className="loginLink">Đã là thành viên của Mandala <Link to={{
                                        pathname: "/login=true",
                                        state: { background: location }
                                    }}>Đăng nhập</Link></div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Register;